import { render, staticRenderFns } from "./unit_handle.vue?vue&type=template&id=83bfd276&scoped=true&"
import script from "./unit_handle.vue?vue&type=script&lang=js&"
export * from "./unit_handle.vue?vue&type=script&lang=js&"
import style0 from "./unit_handle.vue?vue&type=style&index=0&id=83bfd276&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bfd276",
  null
  
)

export default component.exports